import { HeaderPrimaryButton } from "components/layout/PageHeader";
import { TransitionModal } from "components/modal";
import { CandidateCreateForm } from "core/candidate/create-form";
import { useState } from "react";

export function AddCandidateModal() {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const closeModal = () => setModalIsOpen(false);
  const openModal = () => setModalIsOpen(true);
  
  return (
    <>
      <TransitionModal
        open={modalIsOpen}
        onClose={closeModal}
      >
        <CandidateCreateForm
          onCreate={closeModal}
        />
      </TransitionModal>
      <HeaderPrimaryButton onClick={openModal}>
        Ajouter un candidat
      </HeaderPrimaryButton>
    </>
  );
}
